// extracted by mini-css-extract-plugin
export default {"main":"NavbarShare_main__A6xfW"};